global.suite('', function () { require("/Users/masachika/src/github.com/oprstchn/react-chart-editor/src/__percy__/panels.percy.js"); });


// WEBPACK FOOTER //
// /private/var/folders/l6/tzd831c53fj82q59w2p7q27m0000gn/T/tmp-39636HUanCD9QfLT.js